import { ChipClassKey } from '@material-ui/core/Chip';
import { alpha, emphasize, Theme } from '@material-ui/core/styles';
import tokens from '../tokens';

const MuiChip = (theme: Theme): Partial<Record<ChipClassKey, unknown>> => {
    const backgroundColor = theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[600];
    const color = theme.palette.type === 'light' ? theme.palette.grey[600] : theme.palette.grey[300];
    return {
        root: {
            backgroundColor,
            borderRadius: tokens.radii.rounded,
            color,
            display: 'inline-flex',
            fontSize: theme.typography.pxToRem(16),
            fontWeight: theme.typography.fontWeightMedium,
            verticalAlign: 'baseline',
        },
        icon: {
            color: theme.palette.primary.main,
        },
        deleteIcon: {
            color,
            '&:hover': {
                color: alpha(color, 0.6),
            },
        },
        sizeSmall: {
            height: 18,
            borderRadius: tokens.radii.semiRounded,
            fontSize: theme.typography.pxToRem(13),
        },
        iconSmall: {
            fontSize: theme.typography.pxToRem(18),
            marginLeft: 4,
            marginRight: -4,
        },
        deleteIconSmall: {
            fontSize: theme.typography.pxToRem(16),
            marginRight: 4,
            marginLeft: -4,
        },
        deletable: {
            '&:focus': {
                backgroundColor: emphasize(backgroundColor, 0.08),
            },
        },
        clickable: {
            userSelect: 'none',
            WebkitTapHighlightColor: 'transparent',
            cursor: 'pointer',
            '&:hover, &:focus': {
                backgroundColor: emphasize(backgroundColor, 0.08),
            },
            '&:active': {
                boxShadow: theme.shadows[1],
            },
        },
    };
};

export default MuiChip;
